import React, { useContext } from "react";
import clsx from "clsx";
import WebProfileContext from "@WebProfileContext";
import ReactLink from "@micado-digital/react-link/ReactLink";

import styles from "./Logo.styles";

const Logo = () => {
	const [profileData] = useContext(WebProfileContext);
	const css = styles();

	const logo = profileData?.logos?.find(item => item?.identifier === "logo")?.filename;

	return (
		<div className={clsx(css.logo, "mco-view-component-footer-logo")}>
			<ReactLink to="/">
				<img src={logo} alt="BKH St.Johann" height={99} width={240} loading="lazy" />
			</ReactLink>
		</div>
	);
};

export default Logo;
